import { FC, useState } from 'react'
import { Box, CircularProgress, DialogContent, IconButton, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import theme from 'theme'
import ThemeButton from 'ui/components/buttons/theme/Button'
import { CustomizedDialog } from '../customize-report-dialog/customizeReportDialog.styles'

interface DeleteTemplateDialogProps {
  isOpen: boolean
  templateName: string
  onClose: () => void
  onConfirm: () => Promise<void>
}

const DeleteTemplateDialog: FC<DeleteTemplateDialogProps> = ({ isOpen, templateName, onClose, onConfirm }) => {
  const [isDeleting, setIsDeleting] = useState(false)

  const handleConfirm = async () => {
    try {
      setIsDeleting(true)
      await onConfirm()
    } finally {
      setIsDeleting(false)
    }
  }

  return (
    <CustomizedDialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="delete-template-dialog"
      maxWidth={false}
      sx={{
        '.MuiDialog-paper': {
          width: '664px !important',
          padding: '32px !important',
          minHeight: 'auto'
        }
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', width: '100%', mb: '24px' }}>
        <Typography
          sx={{
            color: theme.colors.menuItemText,
            textAlign: 'center',
            fontFamily: theme.typography.fontFamily.primary,
            fontSize: '28px',
            fontWeight: theme.typography.fontWeight.bold,
            lineHeight: '42px',
            flex: '1 0 0'
          }}
        >
          Delete Template &lsquo;{templateName}&rsquo;
        </Typography>
        <IconButton onClick={onClose} sx={{ color: theme.colors.devicesSecondaryText }}>
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogContent sx={{ p: 0, width: '100%' }}>
        <Typography
          sx={{
            fontSize: theme.typography.fontSize.large,
            color: theme.colors.devicesSecondaryText,
            textAlign: 'center'
          }}
        >
          Are you sure you want to delete the template &quot;{templateName}&quot;?
          <br />
          This action is permanent and the template cannot be restored.
        </Typography>
      </DialogContent>
      <Box sx={{ display: 'flex', gap: 1, width: '100%', mt: '48px' }}>
        <ThemeButton themevariant="secondary" onClick={onClose} disabled={isDeleting} sx={{ flex: 1, height: '48px' }}>
          Cancel
        </ThemeButton>
        <ThemeButton themevariant="primary" onClick={handleConfirm} disabled={isDeleting} sx={{ flex: 1, height: '48px' }}>
          {isDeleting ? <CircularProgress size={18} color="primary" /> : 'Delete'}
        </ThemeButton>
      </Box>
    </CustomizedDialog>
  )
}

export default DeleteTemplateDialog
